"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_11s0lcu36w = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/FileForm.js";
  var hash = "79005a97673df82a6f14c2bd664a3f71667d9b6c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/FileForm.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 30
        },
        end: {
          line: 14,
          column: 47
        }
      },
      "1": {
        start: {
          line: 15,
          column: 34
        },
        end: {
          line: 15,
          column: 53
        }
      },
      "2": {
        start: {
          line: 16,
          column: 46
        },
        end: {
          line: 16,
          column: 71
        }
      },
      "3": {
        start: {
          line: 17,
          column: 19
        },
        end: {
          line: 17,
          column: 30
        }
      },
      "4": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 47,
          column: 4
        }
      },
      "5": {
        start: {
          line: 26,
          column: 27
        },
        end: {
          line: 26,
          column: 52
        }
      },
      "6": {
        start: {
          line: 31,
          column: 27
        },
        end: {
          line: 31,
          column: 54
        }
      },
      "7": {
        start: {
          line: 36,
          column: 27
        },
        end: {
          line: 36,
          column: 60
        }
      },
      "8": {
        start: {
          line: 39,
          column: 25
        },
        end: {
          line: 41,
          column: 12
        }
      },
      "9": {
        start: {
          line: 50,
          column: 0
        },
        end: {
          line: 55,
          column: 2
        }
      },
      "10": {
        start: {
          line: 57,
          column: 0
        },
        end: {
          line: 57,
          column: 49
        }
      }
    },
    fnMap: {
      "0": {
        name: "FileForm",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 17
          }
        },
        loc: {
          start: {
            line: 13,
            column: 3
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 20
          },
          end: {
            line: 26,
            column: 21
          }
        },
        loc: {
          start: {
            line: 26,
            column: 27
          },
          end: {
            line: 26,
            column: 52
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 21
          }
        },
        loc: {
          start: {
            line: 31,
            column: 27
          },
          end: {
            line: 31,
            column: 54
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 36,
            column: 20
          },
          end: {
            line: 36,
            column: 21
          }
        },
        loc: {
          start: {
            line: 36,
            column: 27
          },
          end: {
            line: 36,
            column: 60
          }
        },
        line: 36
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 39,
            column: 19
          },
          end: {
            line: 39,
            column: 20
          }
        },
        loc: {
          start: {
            line: 39,
            column: 25
          },
          end: {
            line: 41,
            column: 12
          }
        },
        line: 39
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "79005a97673df82a6f14c2bd664a3f71667d9b6c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function FileForm(_ref) {
  var _branch = _ref.branch,
      _filepath = _ref.filepath,
      _defaultContent = _ref.defaultContent,
      submitText = _ref.submitText,
      onSubmit = _ref.onSubmit;
  cov_11s0lcu36w.f[0]++;

  var _ref2 = (cov_11s0lcu36w.s[0]++, (0, _react.useState)(_branch)),
      _ref3 = _slicedToArray(_ref2, 2),
      branch = _ref3[0],
      setBranch = _ref3[1];

  var _ref4 = (cov_11s0lcu36w.s[1]++, (0, _react.useState)(_filepath)),
      _ref5 = _slicedToArray(_ref4, 2),
      filepath = _ref5[0],
      setFilepath = _ref5[1];

  var _ref6 = (cov_11s0lcu36w.s[2]++, (0, _react.useState)(_defaultContent)),
      _ref7 = _slicedToArray(_ref6, 2),
      defaultContent = _ref7[0],
      setDefaultContent = _ref7[1];

  var disabled = (cov_11s0lcu36w.s[3]++, !filepath);
  cov_11s0lcu36w.s[4]++;
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    style: {
      marginBottom: '1em',
      padding: '1.3em'
    }
  }, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    disabled: true,
    style: {
      display: 'none'
    },
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement(_core.TextField, {
    name: "branch",
    label: "branch",
    type: "text",
    autoComplete: null,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: branch,
    onChange: function onChange(e) {
      cov_11s0lcu36w.f[1]++;
      cov_11s0lcu36w.s[5]++;
      return setBranch(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement(_core.TextField, {
    name: "filepath",
    label: "filepath",
    type: "text",
    autoComplete: null,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: filepath,
    onChange: function onChange(e) {
      cov_11s0lcu36w.f[2]++;
      cov_11s0lcu36w.s[6]++;
      return setFilepath(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement(_core.TextField, {
    name: "defaultContent",
    label: "defaultContent",
    type: "text",
    multiline: true,
    autoComplete: null,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: defaultContent,
    onChange: function onChange(e) {
      cov_11s0lcu36w.f[3]++;
      cov_11s0lcu36w.s[7]++;
      return setDefaultContent(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Button, {
    type: "button",
    disabled: disabled,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      cov_11s0lcu36w.f[4]++;
      cov_11s0lcu36w.s[8]++;
      return onSubmit({
        branch: branch,
        filepath: filepath,
        defaultContent: defaultContent
      });
    }
  }, submitText)));
}

;
cov_11s0lcu36w.s[9]++;
FileForm.propTypes = {
  /** text to display on the submit button */
  submitText: _propTypes.default.string,

  /** Function run when submit button is clicked */
  onSubmit: _propTypes.default.func.isRequired
};
cov_11s0lcu36w.s[10]++;
FileForm.defaultProps = {
  submitText: 'Submit'
};
var _default = FileForm;
exports.default = _default;